export default __webpack_public_path__ + "static/media/(47).358e6d7a.jpg";